// @flow
import WebComponent from '../src/webComponents/WebComponent';
import 'bootstrap-slider';
import $ from 'jquery';
import {formatCurrency} from '../plugins/utils';

class Slider extends WebComponent {
  constructor(props) {
    super(props);
    this.formatter = this.formatter.bind(this);
  }

  enterDocument() {
    let {
      sliderMin,
      sliderMax,
      sliderStep,
    } = this.props;

    const typeSliderMin = Number.isInteger(parseFloat(sliderMin));
    const typeSliderMax = Number.isInteger(parseFloat(sliderMax));
    const typeSliderStep = Number.isInteger(parseFloat(sliderStep));

    if ((!typeSliderMin || !typeSliderMax) && (typeSliderStep)) {
      sliderStep = parseFloat(`${sliderStep}.1`);
    }

    $(this.element).bootstrapSlider({
      tooltip: 'always',
      tooltip_split: true,
      formatter: this.formatter,
      step: sliderStep,
    });
  }

  formatter(val) {
    const {
      unit,
      ticksTitles,
    } = this.props;

    if (Array.isArray(val)) {
      return `${val[0]} -  ${val[1]} ${unit || ''}`;
    } else {
      if (typeof unit !== "undefined") {
        return `${formatCurrency(val)} ${unit || ''}`;
      } else if (typeof ticksTitles !== "undefined") {
        //az bude podpora na lock tick, tak se to musi predelat
        var tickLabelArr = ticksTitles[Object.keys(ticksTitles)[0]].split(" ");
        if (tickLabelArr.length > 1) {
          return `${formatCurrency(val)} ${tickLabelArr[tickLabelArr.length - 1]}`;
        } else {
          return `${formatCurrency(val)}`;
        }
      }
    }
    return `${formatCurrency(val)}`;
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/Slider.js